export default (function () {
    const woobtProducts = document.querySelector('.woobt-products')
    const woobtSummary = document.querySelector('.woobt-summary')

    if (!woobtProducts || !woobtSummary) return

    const checkboxes = woobtProducts.querySelectorAll('input[type="checkbox"]')

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('click', () => {
            const checkedCount = woobtProducts.querySelectorAll('input[type="checkbox"]:checked').length

            if (checkedCount > 1) {
                woobtSummary.classList.add('show')
            } else {
                woobtSummary.classList.remove('show')
            }
        })
    })
})
